export default /^[^\s@]{1,}@[^\s@]{1,}\.[^\s@]{1,}$/;
